import { BookingSummaryConsentDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';
import { ConsentStatus } from '@/features/dashboard/consentTemplates/types/ConsentStatus.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';

export type ConsentSummaryAction = 'SIGN' | 'DOCUMENT' | 'NONE';

// Status nie wystarcza: wycofana zgoda bywa schowana, a schowanej backend nie da podpisać —
// to, czy zgoda jest żywa, wie tylko `signable`. Anulowana rezerwacja nie przyjmie podpisu nawet,
// gdyby `signable` się prześlizgnęło.
export const consentSummaryAction = (
  consent: Pick<BookingSummaryConsentDto, 'signable' | 'status'>,
  bookingStatus: BookingStatus,
): ConsentSummaryAction => {
  if (consent.signable && bookingStatus !== BookingStatus.CANCELLED) {
    return 'SIGN';
  }
  if (consent.status === ConsentStatus.ACCEPTED) return 'DOCUMENT';
  return 'NONE';
};
